import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "../components/anim";
import Starfield from "../components/Starfield";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FAQS } from "../data/site";

export default function Faq() {
  return (
    <main className="relative min-h-screen overflow-hidden pt-28 pb-20" data-testid="faq-page">
      <Starfield />
      <div className="pointer-events-none absolute -top-32 right-[-10%] h-[420px] w-[420px] rounded-full bg-violet-600/15 blur-[130px]" />
      <div className="relative mx-auto max-w-4xl px-4 sm:px-6">
        <Reveal className="text-center">
          <div className="flex justify-center"><Eyebrow>FAQ</Eyebrow></div>
          <h1 className="mt-4 font-display text-4xl font-bold tracking-tight text-white sm:text-6xl">
            Questions, answered.
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-lg text-slate-400">
            Getting started, timelines, updates — the things every smart client asks before picking up the phone.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-14 rounded-3xl border border-white/10 bg-white/5 px-7 py-4 sm:px-10" data-testid="faq-accordion">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-white/10">
                  <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left text-base font-semibold text-white hover:text-blue-400">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm leading-relaxed text-slate-400">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </Reveal>
        <Reveal className="mt-12 text-center">
          <p className="text-sm text-slate-400">Still curious about something?</p>
          <Link
            to="/contact"
            data-testid="faq-contact-btn"
            className="group mt-4 inline-flex items-center gap-2 rounded-full bg-blue-600 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-blue-700"
          >
            Ask Us Directly
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </main>
  );
}
